import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChevronIcon } from 'src/ui/assets/icons/arrow/ChevronIcon';
import { withConfig } from 'src/withConfig';
import { CountryFlagIcon } from 'src/ui/assets/icons/flags/CountryFlagIcon';

const setTableSportsRowLinkWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            background: ${theme.star.unified.tableSportsRow.link.colors.bgPrimary};
            border: 1px solid ${theme.star.unified.tableSportsRow.link.colors.borderPrimary};

            [class$='RowLinkLabel'] {
                width: auto;
                flex-shrink: 0;
            }

            [class$='RowLinkDetails'] {
                flex-basis: 100%;
                color: ${theme.star.unified.eventRow.txtColorQuaternary};
                font-size: ${theme.star.unified.tableSportsRow.link.typography.fontSizeSecondary};
                line-height: ${theme.star.unified.tableSportsRow.link.typography.lineHeightSecondary};
            }
        `;
    }
    return css`
            background: ${theme.star.tableSportsRow.link.colors.bgPrimary};
            border: 1px solid ${theme.star.tableSportsRow.link.colors.borderPrimary};
        `;
};

export const TableSportsRowLinkWrapper = withConfig(theme => styled('div', { label: 'TableSportsRowLinkWrapper' })<RowLinkDetailsPropsType>`
    ${({ variant }): SerializedStyles => setTableSportsRowLinkWrapper(variant, theme)};
    align-content: center;
    cursor: pointer;
    display: flex;
    flex-flow: row wrap;
    flex: 1 1 auto;
    padding: 8px 48px 8px 12px;
    position: relative;
    width: 100%;
    min-width: 0;
`);

export const TableSportsRowLinkFlag = styled(CountryFlagIcon, { label: 'TableSportsRowLinkFlag' })`
    flex-shrink: 0;
    margin-right: 8px;
`;

export const RowLinkLabelWrapper = styled('div', { label: 'RowLinkLabelWrapper' })`
    align-content: center;
    cursor: pointer;
    display: flex;
    flex-flow: row wrap;
    position: relative;
    width: 100%;
    min-width: 0;
`;

export const RowLinkLabel = withConfig(theme => styled('h4', { label: 'RowLinkLabel' })`
    color: ${theme.star.tableSportsRow.link.colors.txtPrimary};
    font-size: ${theme.star.tableSportsRow.link.typography.fontSizePrimary};
    font-weight: ${theme.star.tableSportsRow.link.typography.fontWeightPrimary};
    line-height: ${theme.star.tableSportsRow.link.typography.lineHeightPrimary};
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`);

interface RowLinkDetailsPropsType {
    variant: DefaultComponentVariantType | null;
}

export const RowLinkDetails = withConfig(theme => styled('div', { label: 'RowLinkDetails' })<RowLinkDetailsPropsType>`
    color: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.tableSportsRow.link.colors.txtSecondary : theme.star.tableSportsRow.link.colors.txtPrimary};
    font-size: ${theme.star.tableSportsRow.link.typography.fontSizeSecondary};
    line-height: ${theme.star.tableSportsRow.link.typography.lineHeightSecondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    &:not(:last-of-type) {
        &::after {
            content: '|';
            margin: 0 4px;
        }
    }
`);

interface ArrowRightPropsType {
    variant: DefaultComponentVariantType | null;
}

const setArrowRight = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            color: ${theme.star.tableSportsRow.link.colors.bgSecondary};
        `;
    }
    return css`
            color: ${theme.star.tableSportsRow.link.colors.bgSecondary};
        `;
};

export const ArrowRight = withConfig(theme => styled(ChevronIcon, { label: 'ArrowRight' })<ArrowRightPropsType>`
    ${({ variant }): SerializedStyles => setArrowRight(variant, theme)};
    bottom: 0;
    height: 16px;
    margin: auto 12px auto auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
`);
